import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {lastValueFrom, Observable} from 'rxjs';
import {PdfDto} from "../model/pdf-dto";

export enum CSCProviders {
    "S8" = "s8",

}

@Injectable({
    providedIn: 'root',
})
export class CscService {
    private baseUrl = '/api/sipo/providers'; // Backend Base URL

    constructor(private http: HttpClient) {
    }

    getAuthorizceUrl(type: CSCProviders): Observable<string> {
        type = CSCProviders.S8;
        return this.http.get(`${this.baseUrl}/${type}/authorize/url`, {responseType: 'text'});
    }

    getAuthorizceUrlPromise(type: CSCProviders): Promise<string> {
        return lastValueFrom(this.getAuthorizceUrl(type));
    }


    postForAccessToken(code: string, subItemId: string): Observable<any> {
        return this.http.post("/api/sipo/providers/tokens/" + code + "/" + subItemId, {});
    }

    postSignHashes(subItemId: string, credentialID: string, credential_access_token: string): Observable<any> {
        // const payload = {
        //     credentialID: credentialID,
        //     credential_access_token: credential_access_token,
        // }

        const payload = {
            docId: subItemId,
            credentialID: credentialID,
            credential_access_token: credential_access_token,
        }

        return this.http.post("/api/sipo/providers/signhashes", payload);
    }

}
